import {useState, useEffect} from 'react';
import { APIEndpoint, EndpointType, httpGet } from '../utils/apiService'
import { StorefrontResponse, Storefront } from '../models/StorefrontResponse';

const apiURL =  APIEndpoint(EndpointType.Storefront);

export const useStorefronts = () => {
    const [storefronts, setStorefronts] = useState<Storefront[]>([])
    const [storefrontError, setError] = useState("")
    const [storefrontLoading, setLoading] = useState(false)

    useEffect(() => {        
        setStorefronts([])
        setLoading(true)
        setError("")
        httpGet(apiURL)
            .then((data) => {
                const storefrontResponse = data as StorefrontResponse;
                
                if (storefrontResponse.status == "error") {
                    setError(storefrontResponse.errorMessage)
                    setStorefronts([])
                    return
                }
                
                setStorefronts(storefrontResponse.storefronts);
            })
            .catch((error) => setError(error))
            .finally(() => setLoading(false))
    }, []);

    return { storefronts, storefrontLoading, storefrontError };
};